import axios from 'axios'

class ValidacaoDocumentoApiClient {

    async validarDocumento(codigo) {
        return await axios.post('/compra-direta/api/public/v1/compras-diretas/validardocumento', {codigoAcesso: codigo})
    }

    async baixarDocumentos(idVirtualizado){
        return await axios.get(`/compra-direta/api/public/v1/compras-diretas/documentos/download/${idVirtualizado}`,
            {
                responseType: 'arraybuffer'
            })
    }
}

export default new ValidacaoDocumentoApiClient()
